import {DragDropContext, Droppable, DropResult} from '@hello-pangea/dnd';
import {Box} from '@mui/material';
import React, {useCallback} from 'react';
import {RenderBoardItemCommonTypes} from '../RenderBoardViews';
import KanbanColumn from './KanbanColumns/KanbanColumn';
import {KanbanColumnSkeleton} from './KandabSkeletons';
import {useItemDataState} from 'providers';

interface AppKanbanBoardProps extends RenderBoardItemCommonTypes {}

export const AppKanbanBoard: React.FC<AppKanbanBoardProps> = ({
    getAllStatusesLoading,
    selectedBoardView,
    itemStatuses,
}) => {
    const {onDragEndKanbanItemHandler} = useItemDataState();
    const handleDragEnd = useCallback(
        (value: DropResult) => {
            if (itemStatuses) {
                onDragEndKanbanItemHandler(value, itemStatuses);
            }
        },
        [onDragEndKanbanItemHandler, itemStatuses],
    );

    return (
        <Box height="100%" width="100%" sx={{display: 'flex', overflow: 'hidden'}}>
            <DragDropContext onDragEnd={handleDragEnd}>
                <Droppable droppableId="statuses" direction="horizontal" type="column">
                    {provided => (
                        <Box
                            ref={provided.innerRef}
                            id="scrollableDiv"
                            position={'relative'}
                            sx={{
                                display: 'flex',
                                flexGrow: 1,
                                overflow: 'auto',
                                height: 'calc(100vh - 130px)',
                                scrollbarWidth: 'thin',
                                paddingBottom: '10px',
                            }}
                            {...provided.droppableProps}
                        >
                            {getAllStatusesLoading && !selectedBoardView ? (
                                <KanbanColumnSkeleton />
                            ) : (
                                itemStatuses?.map((column, index) => (
                                    <Box key={column.id} sx={{flex: 1, height: '100%'}} pr={'2px'}>
                                        <KanbanColumn
                                            selectedBoardView={selectedBoardView}
                                            column={column}
                                            index={index}
                                        />
                                    </Box>
                                ))
                            )}

                            {provided.placeholder}
                        </Box>
                    )}
                </Droppable>
            </DragDropContext>
        </Box>
    );
};

export default AppKanbanBoard;
